<template>
  <div>
    <v-btn
      color="#00a0d0"
      size="large"
      @click="openFlipbook"
      prepend-icon="mdi-book-open-page-variant"
    >
      {{ label }}
    </v-btn>

    <VImageFlipbook
      ref="flipbookRef"
      :image-urls="imageUrls"
      :pdf-url="pdfUrl"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VImageFlipbook from './VImageFlipbook.vue'

interface Props {
  imageUrls: string[]
  pdfUrl?: string
  label?: string
}

const props = withDefaults(defineProps<Props>(), {
  label: 'Číst magazín'
})

const flipbookRef = ref<InstanceType<typeof VImageFlipbook> | null>(null)

const openFlipbook = () => {
  flipbookRef.value?.open()
}
</script>
